import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadProducts (campaignId, search) {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/products/', { params: { campaign: campaignId, limit: 5, offset: 0, search: search || '', ordering: '-creation_date', is_archived: false } }).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadProduct (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/products/${id}/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadProductStcData (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/products/${id}/stc-data/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
